module.exports = __webpack_public_path__ + "static/img/bf-dia-bg.468ebc87.png";